var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import posthog from 'posthog-js';
import Component from 'vue-class-component';
import Vue from 'vue';
import UiTextInput from 'ui/v1/controls/UiTextInput.vue';
import UiTalentPicker from 'ui/v1/controls/UiTalentPicker.vue';
import { Prop, Ref } from 'vue-property-decorator';
import { container } from 'tsyringe';
import { CompanyRepository } from 'packages/company/CompanyRepository';
import TemplateEditor from 'ui/v1/email/TemplateEditor.vue';
import Popper from 'vue-popperjs';
import { templateTypeMap } from 'packages/email/entities/EmailTemplate';
import { EmailTemplateGroupRepository } from 'packages/email/EmailTemplateGroupRepository';
import UiRichPicker from 'ui/v1/controls/UiRichPicker.vue';
import UiPickerGroup from 'ui/v1/controls/picker/UiPickerGroup.vue';
import { TalentService } from 'packages/talent/TalentService';
import UiTextButton from 'ui/v1/controls/UiTextButton.vue';
import { Job } from 'packages/v3/jobs/Job';
import UiInfoBox from 'ui/v1/UiInfoBox.vue';
import AppLink from 'ui/v1/navigation/AppLink.vue';
import env from 'config/env';
import { Getter, namespace } from 'vuex-class';
import { User } from 'packages/users/User';
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue';
import TemplateGeneratorFlyout from 'ui/v1/email/TemplateGeneratorFlyout.vue';
import isNil from 'common/support/isNil';
import uuid from 'uuid/v4';
import moment from 'moment';
import { getDraftGptLanguageByValue, } from 'packages/email/gpt-draft/data/gptDraftLanguages';
export var DraftState;
(function (DraftState) {
    DraftState["START"] = "start";
    DraftState["UPDATE"] = "update";
    DraftState["GENERATED"] = "generated";
})(DraftState || (DraftState = {}));
var profile = namespace('profile');
var talentEmailModule = namespace('talentCard/talentEmailState');
var EmailComposer = /** @class */ (function (_super) {
    __extends(EmailComposer, _super);
    function EmailComposer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyRepository = container.resolve(CompanyRepository);
        _this.templateGroupRepository = container.resolve(EmailTemplateGroupRepository);
        _this.talentService = container.resolve(TalentService);
        _this.draftState = null;
        _this.manageTemplateUrl = env.APPS.SETTINGS.URL + "email/templates";
        _this.from = null;
        _this.senderOptions = [];
        _this.chosenTemplate = null;
        _this.emailTemplateGroups = [];
        _this.composerState = {
            body: '',
            subject: '',
            uuid: uuid(),
        };
        _this.touched = {
            body: false,
            subject: false,
        };
        _this.flyoutToggled = false;
        _this.bodyHasManualInput = false;
        _this.gptBodyBuffer = [];
        _this.gptDraftBody = null;
        _this.userHasDraftedWithAi = false;
        _this.generationData = null;
        // index increments each time a new time gpt draft is received,
        // so next index will be 0 and will match the first item in the buffer
        _this.currentDraftBodyIndex = -1;
        return _this;
    }
    Object.defineProperty(EmailComposer.prototype, "shouldShowReloadButton", {
        get: function () {
            if (this.chosenTemplate === null) {
                return false;
            }
            var replacer = this.$refs.templateEditor.placeholderHelper.replaceElementsWithTags;
            return (this.chosenTemplate.body !== null &&
                replacer(this.composerState.body) !== replacer(this.chosenTemplate.body)) || this.chosenTemplate.subject !== null &&
                this.composerState.subject !== this.chosenTemplate.subject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailComposer.prototype, "candidatesWithoutName", {
        get: function () {
            return this.candidates.filter(function (candidate) { return candidate.name === null; }).length;
        },
        enumerable: false,
        configurable: true
    });
    EmailComposer.prototype.mounted = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var company, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.companyRepository.find(this.currentCompanyId.toString())];
                    case 1:
                        company = _c.sent();
                        this.senderOptions.push({
                            id: this.currentUser.id,
                            displayName: this.$t('common.me') + " (" + this.currentUser.name + " - " + company.name + ")",
                            type: 'user',
                        });
                        this.from = this.senderOptions[0];
                        this.senderOptions.push({
                            id: company.id,
                            displayName: company.name,
                            type: 'company',
                        });
                        if (this.isReplying) {
                            this.composerState.subject = (_a = this.threadSubject) !== null && _a !== void 0 ? _a : this.composerState.subject;
                        }
                        _b = this;
                        return [4 /*yield*/, this.templateGroupRepository.getTemplateGroupsForCompany(this.currentCompanyId)];
                    case 2:
                        _b.emailTemplateGroups = _c.sent();
                        this.assignDefaultTemplate();
                        this.updateBodyAndSubject();
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailComposer.prototype.openSenderDropdown = function (e) {
        e.cancelBubble = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.$refs.senderDropdown.activate();
    };
    EmailComposer.prototype.reset = function () {
        this.composerState.subject = '';
        this.composerState.body = '';
    };
    Object.defineProperty(EmailComposer.prototype, "draftLoading", {
        get: function () {
            return this.draftState === DraftState.START || this.draftState === DraftState.UPDATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailComposer.prototype, "isValid", {
        get: function () {
            if (!this.composerState.body || !this.composerState.subject) {
                this.touched = {
                    subject: true,
                    body: true,
                };
            }
            if (this.touched.body && !this.composerState.body) {
                return false;
            }
            if (this.touched.subject && !this.composerState.subject) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    EmailComposer.prototype.send = function (thread) {
        if (this.isValid) {
            return this.talentService.sendMailToTalents(this.candidates, this.composerState.subject, this.$refs.templateEditor.placeholderHelper.replaceElementsWithTags(this.composerState.body), this.isReplying && thread ? thread.id : null, this.job.id, this.from.type === 'company' ? this.from.id : null);
        }
    };
    EmailComposer.prototype.updateBodyAndSubject = function () {
        if (!this.chosenTemplate) {
            return;
        }
        this.composerState.body = this.chosenTemplate.body ?
            this.$refs.templateEditor.placeholderHelper.replaceTagsWithElements(this.chosenTemplate.body) :
            this.composerState.body;
        this.composerState.subject = this.chosenTemplate.subject || this.composerState.subject;
        this.$emit('templateSelected', this.chosenTemplate.id);
    };
    EmailComposer.prototype.assignDefaultTemplate = function () {
        var _this = this;
        if (!this.status || !Object.values(templateTypeMap).includes(this.status)) {
            return;
        }
        this.chosenTemplate = this.emailTemplateGroups
            .reduce(function (templates, group) { return templates.concat(group.templates); }, [])
            .find(function (template) { return template.types
            .map(function (type) { return type.type; })
            .includes(_this.status); }) || null;
    };
    Object.defineProperty(EmailComposer.prototype, "disableQuill", {
        get: function () {
            return this.flyoutToggled || this.draftLoading;
        },
        enumerable: false,
        configurable: true
    });
    EmailComposer.prototype.onFlyoutToggled = function (state) {
        this.flyoutToggled = state;
    };
    EmailComposer.prototype.onDraft = function (payload) {
        var _a;
        this.chosenTemplate = null;
        if (payload.state === this.draftState) {
            return;
        }
        if ([DraftState.START, DraftState.UPDATE].includes(payload.state)) {
            if (this.bodyHasManualInput && !window.confirm(this.$t('messaging.generate_template.warning'))) {
                return;
            }
            this.generationData = {
                state: payload.state,
                generationOptions: payload.generationOptions,
                timeToGenerate: moment(),
            };
        }
        if (payload.state === DraftState.GENERATED && !isNil((_a = payload.gptResponse) === null || _a === void 0 ? void 0 : _a.message)) {
            this.sendPosthogEvent();
            this.gptDraftBody = payload.gptResponse.message;
            this.touched.body = true;
            this.bodyHasManualInput = false;
        }
        this.userHasDraftedWithAi = true;
        this.draftState = payload.state;
    };
    EmailComposer.prototype.sendPosthogEvent = function (state) {
        if (!this.userHasDraftedWithAi || isNil(this.generationData)) {
            return;
        }
        var options = this.generationData.generationOptions;
        var language = getDraftGptLanguageByValue(options.lang).toLowerCase();
        var hasTimeRecorded = !isNil(this.generationData.timeToGenerate);
        var isInterviewType = options.emailType === 'interview';
        posthog.capture('Email AI generation', {
            user_id: this.currentUser.id,
            state: state !== null && state !== void 0 ? state : this.generationData.state,
            action: (state !== null && state !== void 0 ? state : this.generationData.state) + " '" + (isInterviewType ? 'meeting scheduling' : options.emailType) + "' email in '" + options.tone + "' tone using '" + language + "' language",
            email_type: options.emailType,
            tone: options.tone,
            language: language,
            time_to_generate: hasTimeRecorded ? moment().diff(this.generationData.timeToGenerate, 'milliseconds') : null,
        });
        this.generationData.timeToGenerate = null;
    };
    EmailComposer.prototype.onGptBodyParsed = function () {
        var gptGeneratedBodyUuid = uuid();
        this.gptBodyBuffer.push({
            body: this.composerState.body,
            uuid: gptGeneratedBodyUuid,
        });
        this.composerState.uuid = gptGeneratedBodyUuid;
        this.currentDraftBodyIndex += 1;
    };
    EmailComposer.prototype.regenerateGptDraftBody = function () {
        this.templateGeneratorFlyout.triggerDraft();
    };
    Object.defineProperty(EmailComposer.prototype, "isAiGenerated", {
        get: function () {
            var _this = this;
            return this.gptBodyBuffer.some(function (gptBody) { return gptBody.uuid === _this.composerState.uuid; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailComposer.prototype, "allowRevertOptions", {
        get: function () {
            var showRevertOptions = {
                revertArrow: false,
                proceedArrow: false,
            };
            if (this.gptBodyBuffer.length === 1 || this.bodyHasManualInput === true || this.composerState.body.length === 0) {
                return showRevertOptions;
            }
            if (this.gptBodyBuffer[this.currentDraftBodyIndex - 1]) {
                showRevertOptions.revertArrow = true;
            }
            if (this.gptBodyBuffer[this.currentDraftBodyIndex + 1]) {
                showRevertOptions.proceedArrow = true;
            }
            return showRevertOptions;
        },
        enumerable: false,
        configurable: true
    });
    EmailComposer.prototype.revertBodyFromBuffer = function (action) {
        if (this.gptBodyBuffer.length < 2) {
            return;
        }
        if (action === 'undo' && this.currentDraftBodyIndex === 0) {
            return;
        }
        if (action === 'redo' && this.currentDraftBodyIndex === this.gptBodyBuffer.length) {
            return;
        }
        if (action === 'undo') {
            this.composerState.body = this.gptBodyBuffer[this.currentDraftBodyIndex - 1].body;
            this.currentDraftBodyIndex -= 1;
            return;
        }
        if (action === 'redo') {
            this.composerState.body = this.gptBodyBuffer[this.currentDraftBodyIndex + 1].body;
            this.currentDraftBodyIndex += 1;
        }
    };
    var _a, _b, _c;
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_a = typeof TemplateGeneratorFlyout !== "undefined" && TemplateGeneratorFlyout) === "function" ? _a : Object)
    ], EmailComposer.prototype, "templateGeneratorFlyout", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Number)
    ], EmailComposer.prototype, "currentCompanyId", void 0);
    __decorate([
        profile.State('user'),
        __metadata("design:type", typeof (_b = typeof User !== "undefined" && User) === "function" ? _b : Object)
    ], EmailComposer.prototype, "currentUser", void 0);
    __decorate([
        talentEmailModule.Mutation,
        __metadata("design:type", Function)
    ], EmailComposer.prototype, "setSelectedThread", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_c = typeof Job !== "undefined" && Job) === "function" ? _c : Object)
    ], EmailComposer.prototype, "job", void 0);
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", Array)
    ], EmailComposer.prototype, "candidates", void 0);
    __decorate([
        Prop({ default: null }),
        __metadata("design:type", String)
    ], EmailComposer.prototype, "status", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], EmailComposer.prototype, "isReplying", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmailComposer.prototype, "threadSubject", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], EmailComposer.prototype, "allowAiGeneration", void 0);
    EmailComposer = __decorate([
        Component({
            components: {
                TemplateGeneratorFlyout: TemplateGeneratorFlyout,
                AppLink: AppLink,
                UiInfoBox: UiInfoBox,
                UiTextButton: UiTextButton,
                UiPickerGroup: UiPickerGroup,
                UiRichPicker: UiRichPicker,
                Popper: Popper,
                TemplateEditor: TemplateEditor,
                UiTalentPicker: UiTalentPicker,
                UiTextInput: UiTextInput,
                VueMultiselect: VueMultiselect,
            },
        })
    ], EmailComposer);
    return EmailComposer;
}(Vue));
export default EmailComposer;
